document.addEventListener('DOMContentLoaded', () => {
    m.marketing.saveUrlParams();
});
